import React from 'react';
import classnames from 'classnames';
import './PaginationNav.scss';

type OuterProps = {
  onChangePage: (page: number) => void;
  activePage: number;
  page: number;
  label: string;
  circularActive: boolean | undefined;
  squareActive?: boolean;
};

type Props = OuterProps;

export const PageNumber = (props: Props) => {
  const {
    onChangePage,
    activePage,
    page,
    label,
    circularActive,
    squareActive,
  } = props;

  const pageClassList = classnames('pagination-nav__page-link', {
    'pagination-nav--active':
      !circularActive && !squareActive && page === activePage,
    'pagination-nav-circular--active': circularActive && page === activePage,
    'pagination-nav-square__page_link': squareActive && page !== activePage,
    'pagination-nav-square--active': squareActive && page === activePage,
  });

  return (
    <div
      key={page}
      className={pageClassList}
      onClick={() => onChangePage(page)}
    >
      {label}
    </div>
  );
};
